import React from 'react';
import { CheckIcon } from 'lucide-react';
type Level = {
  label: string;
  text: string;
};
type VolumeCardProps = {
  label: string;
  title: string;
  subtitle: string;
  points: string[];
  tagline?: string;
  levels?: Level[];
  afterPoints?: string[];
  finalLine: string;
  meta?: string;
};
export function VolumeCard({
  label,
  title,
  subtitle,
  points,
  tagline,
  levels,
  afterPoints,
  finalLine,
  meta
}: VolumeCardProps) {
  return <article className="overflow-hidden rounded-md border border-line bg-white" data-id="element-206" data-mp="1uswed72p4itf">
      <div className="flex items-center gap-2 bg-navy px-3 py-2" data-id="element-207" data-mp="1pvmj3asmlcxo">
        <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-[3px] bg-check" aria-hidden data-id="element-208" data-mp="1l3cv40b2mmy1">
          <CheckIcon className="h-3 w-3 text-white" strokeWidth={4} data-id="element-209" data-mp="1h2t1v7tmc3h6" />
        </span>
        <h3 className="font-heading text-[13px] font-extrabold uppercase leading-tight text-white md:text-[15px]" data-id="element-210" data-mp="2djnpoe68ujag">
          {label} — {title}
        </h3>
      </div>
      <div className="px-3 py-2.5 md:px-4 md:py-3" data-id="element-211" data-mp="28r2w9dr9287g">
        <p className="font-heading text-[13px] font-bold leading-snug text-brand md:text-[14px]" data-id="element-212" data-mp="37d1xv08qv6c6">{subtitle}</p>
        {tagline && <p className="mt-1 font-heading text-[12px] font-extrabold uppercase leading-tight text-goldDark md:text-[13px]" data-id="element-213" data-mp="3cabtixmq8e8g">
            {tagline}
          </p>}
        <div className="mt-1.5 space-y-1 text-[14px] leading-[1.4] text-ink md:text-[15px]" data-id="element-214" data-mp="32k8vgj0r0a39">
          {points.map(p => <p key={p} data-id="element-215" data-mp="2ok7u72gkn0n9">{p}</p>)}
        </div>
        {levels && <dl className="mt-2 divide-y divide-line rounded-md border border-line bg-surface" data-id="element-216" data-mp="2tldo33lywtyd">
            {levels.map(l => <div key={l.label} className="px-3 py-2 text-[14px] leading-[1.4] md:text-[15px]" data-id="element-217" data-mp="2epfwzzqwift0">
                <dt className="font-heading text-[12px] font-extrabold uppercase text-navy md:text-[13px]" data-id="element-218" data-mp="2joipyltlwvkm">{l.label}</dt>
                <dd className="mt-0.5 text-ink" data-id="element-219" data-mp="hv2wlh64x2ly">{l.text}</dd>
              </div>)}
          </dl>}
        {afterPoints && <div className="mt-2 space-y-1 text-[14px] leading-[1.4] text-ink md:text-[15px]" data-id="element-220" data-mp="gep5qrxne1jj">
            {afterPoints.map(p => <p key={p} data-id="element-221" data-mp="bgw1i4fwnhlw">{p}</p>)}
          </div>}
        <p className="mt-2 font-heading text-[12px] font-extrabold uppercase leading-tight text-brand md:text-[13px]" data-id="element-222" data-mp="6ghrwhynnzlr">
          {finalLine}
        </p>
        {meta && <p className="mt-1 text-[12px] font-semibold text-ink/70 md:text-[13px]" data-id="element-223" data-mp="z4x3svmhq1sv">{meta}</p>}
      </div>
    </article>;
}